import { StringUtils } from '../utils/string.util';
import { LoggerLevelEnum } from '../enums/logger-level.enum';
import { LoggerProvider } from "../services/logger-provider.service";

/**
 * Log function call information automatically.
 *
 * @export
 * @param {(...Array<string | LoggerLevelEnum>)} logArgs
 * @return {*}  {MethodDecorator}
 */
export function AutoLog(...logArgs: Array<string | LoggerLevelEnum>): MethodDecorator {
  return (target: Object, propertyKey: string | symbol, descriptor: PropertyDescriptor): PropertyDescriptor => {
    const originalMethod = descriptor.value;
    descriptor.value = function (...args: any[]) {
      const key = propertyKey as string;
      const logger = LoggerProvider.getLogger();
      if (!logger) {
        throw 'Logger is null or undefined.';
      }
      const level: LoggerLevelEnum = (logArgs.length === 0 || !(logArgs[logArgs.length - 1] in LoggerLevelEnum))
        ? LoggerLevelEnum.Trace : logArgs[logArgs.length - 1] as LoggerLevelEnum;
      const categoryStr = logArgs.filter(x => typeof(x) === 'string')
        .map(x => x as string)
        .map(x => StringUtils.isEmpty(x) ? StringUtils.EMPTY : `[${x}]`)
        .join();
      logger.log(level, `[AutoLog] ${categoryStr} [${target.constructor.name}] => ${key} - begin - arguments:`, args);
      const result = originalMethod.apply(this, args);
      logger.log(level, `[AutoLog] ${categoryStr} [${target.constructor.name}] => ${key} - end - result:`, [result])

      return result;
    };
    return descriptor;
  };
}
